"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "tortoreto": {
    "eb000cc7": [{
      "hkey": "0b61988a",
      "slug": "tortoreto",
      "name": "Tortoreto",
      "primary": true,
      "skipSearch": false
    }],
    "terrabianca": [{
      "hkey": "0b61988a",
      "slug": "tortoreto",
      "name": "Tortoreto",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "983614b5": [{
      "hkey": "6b85bfcc",
      "slug": "tortoreto-lido",
      "name": "Tortoreto Lido",
      "primary": true,
      "skipSearch": false
    }],
    "zona-mare": [{
      "hkey": "6b85bfcc",
      "slug": "tortoreto-lido",
      "name": "Tortoreto Lido",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "tortoreto"
    }]
  }
};
exports["default"] = _default;